export const visualResearchTags = [
  "3h8ecj38fk554a5j439bm4l4ch27dh3g",
  "b85dd5a16fcd41cf87e292d5733d660f",
  "f9321d1337744e44831048435055ae54",
  "acb2f5d0e759439c8cd5aec44a1d8265"
];export const visualResearchTags = [
  "3h8ecj38fk554a5j439bm4l4ch27dh3g",
  "b85dd5a16fcd41cf87e292d5733d660f",
  "f9321d1337744e44831048435055ae54",
  "acb2f5d0e759439c8cd5aec44a1d8265"
];